"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const MemoryRepository_1 = require("../../Common/Port/MemoryRepository");
const Fudao_1 = require("../Fudao");
class FudaoMemRepository extends MemoryRepository_1.MemRepository {
    FudaoOfId(id) {
        return this.Load(id);
    }
    async FudaoOfIdAsync(id) {
        return await this.LoadAsync(id);
    }
    async FudaoOfStatusAsync(status) {
        const allItems = await this.allItemAsync();
        return allItems.filter(fudao => fudao.Status === status);
    }
    async SaveAsync(fudao) {
        if (!super.contains(fudao.id)) {
            super.save(fudao);
        }
        else {
            super.update(fudao);
        }
    }
    async LoadAsync(fudaoId) {
        return this.Load(fudaoId);
    }
    async ClearAsync() {
        await super.clearAsync();
    }
    Load(id) {
        const loaded = super.load(id);
        if (!loaded)
            return Fudao_1.Fudao.INVALID_FUDAO;
        else
            return loaded;
    }
}
exports.FudaoMemRepository = FudaoMemRepository;
//# sourceMappingURL=FudaoMemRepository.js.map